'use client'
import { LoginDto } from '@/features/auth/login-by-email'
import { signIn } from 'next-auth/react'

export interface UpdateCurrentUserByTokenParams extends Partial<LoginDto> {}

const updatecurrentuserbytoken = async (params: UpdateCurrentUserByTokenParams) => {
  const data: UpdateCurrentUserByTokenParams = {
    ...params,
    action: 'signin-by-token',
  }
  const res = await signIn('credentials', { redirect: false, ...data })
  return res
}

export default updatecurrentuserbytoken
